export default __webpack_public_path__ + "static/OptimaNovaLTProLight-dcc278d0ab3e4bd48708017f40d764ad.woff2";